(function($) {
    'use strict';
    var QuestionBox2 = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$questions = this.$el.find('.question-box-item');
        this.$steps = this.$el.find('.question-box-step-indicator');
        this.$submit = this.$el.find('.field-submit');
        this.$reset = this.$el.find('.question-box-reset');
        this.$result = this.$el.find('.question-box-result');
        this.$checkBtn = this.$el.find('.btn-check-next');
        this.settings = $.extend(
            {
                speed: 200,
                layout: 'steps',
                showAll: false,
                optional: false
            },
            this.settings,
            this.$el.data()
        );
        this.init();
    };
    QuestionBox2.prototype = {
        currentIndex: 0,
        nextIndex: 0,
        numberOfQuestions: 0,
        init: function() {
            var that = this;
            that.numberOfQuestions = that.$questions.length;
            that.bindEvents();
            that.checkQuestionForCheckboxes();
            if (that.settings.layout === 'no-steps' && !that.settings.showAll) {
                that.addNavButtons();
            }
            if (that.settings.optional) {
                that.$checkBtn.removeClass('btn-hide');
                that.$checkBtn.removeClass('btn-inactive');
                that.$el.find('.question-box-step').each(function() {
                    $(this).addClass('done');
                });
            }
            that.activateSubmit();
        },
        bindEvents: function() {
            var that = this;
            that.$el.parents('.form').unbind('submit');
            that.$steps.on('click', function() {
                var $step = $(this);
                if ($step.parent().hasClass('active')) {
                    return;
                }
                that.nextIndex = $step.data('question');
                that.$steps.parent().removeClass('active');
                $step.parent().addClass('active');
                that.showQuestion();
            });
            that.$questions.find('textarea').on('keyup', function() {
                var anyChecked = false;
                if ($(this).val().trim()) {
                    anyChecked = true;
                }
                if (
                    anyChecked &&
                    that.currentIndex !== that.$questions.size() - 1 &&
                    that.settings.optional !== 1
                ) {
                    that.$el.find('.btn-check-next').removeClass('btn-inactive');
                } else if (
                    !that.$el.find('.btn-check-next').hasClass('btn-inactive') &&
                    that.settings.optional !== 1
                ) {
                    that.$el.find('.btn-check-next').addClass('btn-inactive');
                }
                that.$steps.eq(that.nextIndex).parent().addClass('done');
                that.activateSubmit();
                if (
                    $.trim($('#hdnTextAreaString')[0].value).length === 0 &&
                    that.settings.optional !== 1
                ) {
                    $('#ContentPlaceHolder1_ucQuestionStep_question_submit').addClass(
                        'btn-inactive'
                    );
                }
            });
            that.$questions
                .find("input[type='checkbox'],[type='radio']")
                .on('click', function() {
                    var $currentAnswers = that.$el.find('.qa-' + (that.currentIndex + 1));
                    var anyChecked = false;
                    $currentAnswers.each(function() {
                        var $answer = $(this);
                        if ($answer.is(':checked')) {
                            anyChecked = true;
                        }
                    });
                    if (anyChecked && that.currentIndex !== that.$questions.size() - 1) {
                        that.$el.find('.btn-check-next').removeClass('btn-inactive');
                    } else if (
                        !that.$el.find('.btn-check-next').hasClass('btn-inactive') &&
                        !that.settings.optional
                    ) {
                        that.$el.find('.btn-check-next').addClass('btn-inactive');
                    }
                    that.$steps.eq(that.nextIndex).parent().addClass('done');
                    that.activateSubmit();
                    if (that.$questions.has('.no-continue').length < 1) {
                        that.nextQuestion();
                    }
                    if (!that.allAnswered() && !that.settings.optional) {
                        $('#ContentPlaceHolder1_ucQuestionStep_question_submit').addClass(
                            'btn-inactive'
                        );
                    }
                });
            that.$questions.on('click', '.btn-next', function() {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextQuestion();
                }

                return false;
            });
            that.$el.on('click', '.btn-check-next', function() {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextQuestion();
                }

                return false;
            });
            that.$questions.on('click', '.btn-prev', function() {
                if (!$(this).hasClass('btn-inactive')) {
                    that.nextIndex = that.currentIndex - 1;
                    that.showQuestion();
                }

                return false;
            });
            that.$reset.on('click', function(e) {
                that.resetQuestions();
                e.preventDefault();
            });
            that.$submit.on('click', function(e) {
                if (
                    that.allAnswered() === false ||
                    that.$submit.hasClass('btn-inactive')
                ) {
                    e.preventDefault();
                }
            });
        },
        nextQuestion: function() {
            var that = this;
            if (that.settings.layout === 'no-steps' && !that.settings.showAll) {
                that.$questions
                    .eq(that.currentIndex)
                    .find('.btn-next')
                    .removeClass('btn-inactive')
                    .fadeIn(500);
            }
            if (that.currentIndex + 2 <= that.numberOfQuestions) {
                that.nextIndex = that.currentIndex + 1;
                that.showQuestion();
                that.$steps
                    .parent()
                    .removeClass('active')
                    .eq(that.nextIndex)
                    .addClass('active');
            }
            if (
                that.$questions.eq(that.currentIndex).find(':checked').length === 0 &&
                !that.settings.optional
            ) {
                that.$checkBtn.addClass('btn-inactive');
            }
        },
        addNavButtons: function() {
            var that = this,
                $wrapper = $('<div>').addClass('question-box-nav'),
                $next = $('<a>')
                    .addClass('btn btn-no-icon btn-inactive btn-next')
                    .text('Next question')
                    .hide(),
                $prev = $('<a>')
                    .addClass('btn btn-no-icon btn-inverted btn-prev')
                    .text('Previous question'),
                $submit = that.$el.find('.question-box-submit').remove(),
                $question,
                $wrapperClone;
            $('<a>')
                .addClass('question-box-rest')
                .text('Reset the result and start over with the Product finder');
            that.$questions.each(function(index) {
                $question = $(this);
                $wrapperClone = $wrapper.clone();
                $question.append($wrapperClone);
                switch (index) {
                    case 0:
                        $wrapperClone.append($next.clone());
                        break;
                    case that.numberOfQuestions - 1:
                        $wrapperClone.append($prev.clone());
                        $wrapperClone.append($submit);
                        break;
                    default:
                        $wrapperClone.append($prev.clone());
                        $wrapperClone.append($next.clone());
                }
            });
        },
        activateSubmit: function() {
            var that = this;
            if (that.allAnswered() || that.settings.optional) {
                $('[name=qsubmit]').removeClass('btn-inactive');
                $('[name=qsubmit]').removeAttr('disabled');
                that.$submit.removeClass('btn-inactive');
            } else {
                that.$submit.addClass('btn-inactive');
            }
        },
        showQuestion: function() {
            var that = this,
                $current = that.$questions.eq(that.currentIndex),
                $next = that.$questions.eq(that.nextIndex),
                currentAnim = { opacity: 0 };
            that.currentIndex = that.nextIndex;
            if (that.settings.showAll) {
                currentAnim = {};
            }
            $current.animate(currentAnim, that.settings.speed, function() {
                $current.removeClass('active');
                if (!that.settings.showAll) {
                    $next.css('opacity', 0).addClass('active').animate(
                        {
                            opacity: 1
                        },
                        that.settings.speed
                    );
                }
            });
            that.checkIfLastQuestion();
        },
        allAnswered: function() {
            var that = this,
                allAnswered = false;
            var qAnsString = '';
            that.$questions.each(function() {
                var type = $(this).find(':input').attr('type');
                if (type === 'checkbox' || type === 'radio') {
                    if ($(this).find(':checked').length === 0) {
                        allAnswered = false;

                        return false;
                    }

                    var arr = $($(this).find(':checked'));
                    if (arr.length > 0) {
                        $(arr).each(function() {
                            if (qAnsString === '') {
                                qAnsString =
                                    qAnsString + $(this).attr('id').split('option-')[1];
                            } else {
                                qAnsString =
                                    qAnsString +
                                    '|' +
                                    $(this).attr('id').split('option-')[1];
                            }
                        });
                    }
                    allAnswered = true;
                } else if ($('.txtArea').val().length > 0) {
                    allAnswered = true;
                    if (qAnsString === '') {
                        qAnsString =
                            qAnsString +
                            $('.txtArea').attr('id').split('option-')[1] +
                            '-' +
                            $('.txtArea').val();
                    } else {
                        qAnsString =
                            qAnsString +
                            '|' +
                            $('.txtArea').attr('id').split('option-')[1] +
                            '-' +
                            $('.txtArea').val();
                    }
                } else {
                    allAnswered = false;
                }
            });
            $('input[id$=hdnSelectedQuAnsString]').val(qAnsString);
            $('input[id$=hdnTextAreaString]').val($('.txtArea').val());

            return allAnswered;
        },
        resetQuestions: function() {
            var that = this;
            that.$questions.find('input').each(function() {
                $(this).attr('checked', false);
            });
            that.$result.removeClass('active');
            that.$questions.eq(0).addClass('active');
        },
        checkQuestionForCheckboxes: function() {
            var that = this;
            if (that.$questions.has('.no-continue').length > 0) {
                that.$el.find('.btn-check-next').show();
            }
            if (that.currentIndex === that.$steps.length - 1) {
                that.activateSubmit();
                that.$el.find('.btn-check-next').hide();
            }
        },
        checkIfLastQuestion: function() {
            var that = this;
            var nextButton = that.$el.find('.btn-check-next');
            if (that.currentIndex === that.$steps.length - 1) {
                that.activateSubmit();
                nextButton.addClass('btn-inactive');
            } else if (nextButton.hasClass('btn-inactive')) {
                nextButton.removeClass('btn-inactive');
            }
        }
    };
    $.fn.questionBox2 = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('questionBox');
            if (!data) {
                $this.data('questionBox', (data = new QuestionBox2(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.questionBox2.Constructor = QuestionBox2;
})(jQuery);
